"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchBlogPostsRequestStatus = exports.getLatestBlogPost = exports.getBlogPosts = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var _reselect = require("reselect");

var getBlogPosts = function getBlogPosts(state) {
  return state.modules.website.blogs.entities.blogPosts;
};

exports.getBlogPosts = getBlogPosts;
var getLatestBlogPost = (0, _reselect.createSelector)([getBlogPosts], function (blogPosts) {
  return blogPosts.sort(function (a, b) {
    if (a.get('created') > b.get('created')) {
      return 1;
    }

    if (b.get('created') > a.get('created')) {
      return -1;
    }

    return 0;
  }).first();
});
exports.getLatestBlogPost = getLatestBlogPost;
var getFetchBlogPostsRequestStatus = (0, _getRequestStatus.default)(_actions.BlogPostsActionTypes.FETCH_BLOG_POSTS);
exports.getFetchBlogPostsRequestStatus = getFetchBlogPostsRequestStatus;